export default (quantity) => /* html */ `
<span class="unit">${quantity} item${
  quantity > 1 ? "s" : ""
}</span> added to your cart`;
